import { InjectionToken, Signal, Type } from '@angular/core';

export interface FeatureSHeaderCalendarConfig {
  component: Type<unknown>;
  badgeCount?: Signal<number>;
  calendarRoute?: string;
}

export const FEATURE_S_HEADER_CALENDAR_COMPONENT =
  new InjectionToken<FeatureSHeaderCalendarConfig>(
    'FEATURE_S_HEADER_CALENDAR_COMPONENT'
  );
